import { OverflowTooltip } from 'v5/design-system/Tooltip';
import { UnitLayout } from './UnitLayout';
import { UnitTitle } from './UnitTitle';

/**
 * A unit that only shows a text and is never edited: its title as a unit's
 * has it and the value in the height of a field at rest, with no form
 * control, lock or pencil. A value wider than the unit is cut with an
 * ellipsis and shown whole in a tooltip.
 */
export function StaticUnit({
  title,
  value
}: {
  title: string;
  /** `''` reads as "No value". */
  value: string;
}) {
  return (
    <UnitLayout
      titleSlot={<UnitTitle groupTitle={false}>{title}</UnitTitle>}
      actionsSlot={null}
      aboveContentSlot={null}
      belowContentSlot={null}
      contentSlot={
        <div className="flex h-9 min-w-0 items-center text-base">
          {value === '' ? (
            <span className="text-fg-muted">No value</span>
          ) : (
            <OverflowTooltip title={value} align="start">
              <span className="min-w-0 truncate font-semibold text-fg-default">
                {value}
              </span>
            </OverflowTooltip>
          )}
        </div>
      }
      isEditing={false}
      submitState={null}
      interactive={false}
    >
      <div />
    </UnitLayout>
  );
}
